import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import { injectIntl } from 'react-intl'
import 'styles/app/apps/seaLice/main.scss'
import { connect } from 'react-redux'
import FilterBar from 'components/Apps/SeaLiceMonitor/FilterBar'
import SLContent from 'components/Apps/SeaLiceMonitor/SLContent'
import SeaLiceDataLoader from 'components/Apps/SeaLiceMonitor/SeaLiceDataLoader'
import ContentTypeButtonGroup from 'components/Apps/SeaLiceMonitor/FilterBar/ContentTypeButtonGroup'
import { fetchLastSeaLiceDate } from 'reducers/seaLice/reducer'
import SiteFilter from 'components/Apps/SeaLiceMonitor/FilterBar/SiteFilter'
import * as SLHelper from 'helpers/seaLice'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import CircleLoader from 'components/Loading/CircleLoader'

class SeaLice extends Component {
  componentDidMount() {
    this.props.fetchLastSeaLiceDate({ type: 2 })
  }

  render() {
    const { activeDate, activeView, loader, currentApp } = this.props

    if (activeDate === null) {
      return false
    }

    return (
      <div className="module sealice-module">
        <div className="module-head">
          {ifWindowWidthLessThan(992) &&
          activeView === SLHelper.LIST_VIEW_MY_SITES ? (
            <SiteFilter />
          ) : null}
          <Typography className="module-title" variant="h5">
            {currentApp.name}
          </Typography>
          <div className="module-filter">
            <ContentTypeButtonGroup />
            <FilterBar />
          </div>
        </div>
        <div className="module-content sealice-monitor">
          <CircleLoader loading={loader} />
          <div className="widget-box">
            <SLContent activeView={activeView} />
          </div>
        </div>
        <SeaLiceDataLoader />
      </div>
    )
  }
}
export default connect(
  state => ({
    activeDate: state.getIn(['seaLice', 'activeDate']),
    activeView: state.getIn(['seaLice', 'activeView']),
    loader: state.getIn(['seaLice', 'seaLiceLoader']),
  }),
  {
    fetchLastSeaLiceDate,
  },
)(injectIntl(SeaLice))
